module.exports = __webpack_public_path__ + "static/media/Sofy_portfolio_2x.245cf19a.jpeg";